<template>
	<div class="body">
		<div class="body-container">
			
			<div class="group-ctr">
				
				<div class="major-group-action-ctr" v-if="hasLogin == 1">
					<el-button type="primary" icon="el-icon-plus" size="medium"
						@click="createUserGroup()">专业群基础信息录入</el-button>
				</div>
				
				<div class="login-ctr" v-if="hasLogin == 2">
					<div class="login-tips">该功能需要登录后才能使用</div>
					<el-button class="to-login" type="primary" icon="el-icon-s-custom" @click="clickLogin">点击登录</el-button>
				</div>
				<template v-else-if="hasLogin == 1">
					<el-table :data="dataList" border v-if="dataList && dataList.length > 0">
					
						<el-table-column label="专业（群）名称" align="center" prop="name" min-width="1">
							<template v-slot="{ row }">
								<label v-if="row.showEditMajor == 1" style="color: blue;"
									@click="clickEditGroupMajor(row)">{{row.name}}</label>
								<label v-else>{{row.name}}</label>
							</template>
						</el-table-column>
						<el-table-column label="专业数" align="center" prop="major_num" min-width="1">
							<template v-slot="{ row }">
								<label v-if="row.showEditMajor == 1" style="color: blue;"
									@click="clickEditGroupMajor(row)">{{row.major_num}}</label>
								<label v-else>{{row.major_num}}</label>
							</template>
						</el-table-column>
						<el-table-column label="共性行业数" align="center" prop="industry_num" min-width="1">
							<template v-slot="{ row }">
								<label style="color: blue;"
									@click="clickIndustry(row.industryPath)">{{row.industry_num}}</label>
							</template>
						</el-table-column>
						<el-table-column prop="province_name" label="省直辖市" align="center" min-width="3"></el-table-column>
						<el-table-column prop="degreeLevel" label="学历" align="center" min-width="1"></el-table-column>
						<el-table-column label="创建时间" align="center" prop="created_at" min-width="1" />
						<el-table-column label="设置" min-width="3">
							<template v-slot="{ row }">
								<label class="btn-row-ctr">
									<el-button type="primary" icon="el-icon-edit" size="small" v-if="row.showEditMajor == 1"
										@click="clickEditGroupMajor(row)">编辑</el-button>
									<el-button v-if="row.major_num > 0" type="primary" class="el-button--success" icon="el-icon-help" size="small"
										@click="clickIndustry(row.industryPath)">查看</el-button>
					<!-- 				<el-button type="primary" icon="el-icon-message" class="el-button--warning" size="small"
										@click="clickExportGroupReport(row.id)">导出报告</el-button> -->
									<el-button v-if="row.major_num > 0"  type="primary" icon="el-icon-message" class="el-button--danger" size="small"
										@click="clickDelUserGroup(row.id)">删除</el-button>
								</label>
					
							</template>
						</el-table-column>
					</el-table>
					<div v-else class="empty-ctr">
						你还没有专业群，请先新建专业群
					</div>
				</template>

				
				<div class="pagination">
					<pagination v-show="total>0" :total="total" :page.sync="queryParams.page"
						:limit.sync="queryParams.pageSize" @pagination="getUserMajorGroup" />
				</div>
			</div>

		</div>

		<el-dialog :visible.sync="showGroupDialog" title="基础信息" align='center'>
			<div class="create-group-ctr">
				<div class="group-row">
					<label>专业群名字</label>
					<el-input v-model="groupName" placeholder="请输入名字" class="group-input" />
				</div>

				<div class="group-row">
					<label>省直辖市</label>
					<el-select class="group-select" v-model="province" placeholder="请选择" :clearable=true multiple>
						<el-option v-for="item in provinceList" :key="item.province_code" :label="item.province_name"
							:value="item.province_code">
						</el-option>
					</el-select>
					<label class="tips2">支持多选</label>
				</div>
				
				<div class="group-row">
					<label>学历层次</label>
					<el-select class="group-select" v-model="level" placeholder="请选择" :clearable=true>
						<el-option v-for="item in levelList" :key="item.name" :label="item.showName"
							:value="item.name">
						</el-option>
					</el-select>
				</div>
			</div>


			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="confirmCreateGroup()">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="专业设置" :visible.sync="showGroupMajorDialog" append-to-body v-if="showGroupMajorDialog"
			align="center" @close="onGroupDialogClosed">

			<div class="tab-ctr">
				<label v-for="(item,index) in groupAddList"
					:class="['tab-item', index == groupAddIndex ? 'tab-item-s' : '']" :key="index"
					@click="clickAddTab(index)">{{item.name}}</label>
			</div>

			<el-form :inline="true" align="left">
				<el-form-item label="专业大类">
					<el-select v-model="topMajor" placeholder="请输入关键字" class="select-group-width" filterable remote
						:clearable=true reserve-keyword :remote-method="loadGroupTopMajorList"
						@change="changeGroupTopMjor">
						<el-option v-for="item in topMajorList" :key="item.code" :label="item.name" :value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="专业类">
					<el-select v-model="parentMajor" placeholder="请输入关键字" class="select-group-width" :clearable=true
						filterable remote reserve-keyword :remote-method="loadGroupParentMajorList"
						@change="changeGroupParentMajor">
						<el-option v-for="item in parentMajorList" :key="item.code" :label="item.name"
							:value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="专业">
					<el-select v-model="major" placeholder="请输入关键字" class="select-group-width" :clearable=true
						filterable remote reserve-keyword :remote-method="loadGroupMajorList"
						@change="changeGroupMajor">
						<el-option v-for="item in majorList" :key="item.code" :label="item.name" :value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div class="data-table">
				<el-table :data="groupDataList" border>
					<el-table-column prop="name" label="专业" align="center"></el-table-column>
					<el-table-column prop="topMajor" label="专业大类" align="center"></el-table-column>
					<el-table-column prop="parentMajor" label="专业类" align="center"></el-table-column>
					<el-table-column label="操作" align="center">
						<template v-slot="{ row }">
							<el-button type="primary" size="small" @click="clickAddGroupMajor(row.code)"
								v-if="row.isAdd != 1">添加</el-button>
							<el-button type="warning" size="small" @click="clickRemoveGroupMajor(row.code)"
								v-else>移除</el-button>
						</template>
					</el-table-column>

				</el-table>

				<div class="pagination">
					<pagination v-show="groupTotal>0" :total="groupTotal" :page.sync="groupQueryParams.page"
						:limit.sync="groupQueryParams.pageSize" @pagination="queryGroupMajorData" />
				</div>
			</div>
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseGroupDialog()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getAddrTree,
		getUserMajorGroup,
		createMajorGroup,
		getGroupTopMajorList,
		getGroupParentMajorList,
		getGroupMajorList,
		getGroupMajor,
		addGroupMajor,
		removeGroupMajor,
		deleteUserGroup,
		getGroupPageConfig
	} from "@/api/matrix"

	import {
		isEmpty
	} from "@/utils/util"
	
	import {
		useLoginStore
	} from "@/utils/login"

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	export default {
		name: "Matrix",
		data() {
			return {
				leftTabList: [],
				activeLeftTab: 0,
				topMajorList: [],
				topMajor: undefined,
				parentMajorList: [],
				parentMajor: undefined,
				majorList: [],
				major: undefined,
				provinceList: [],
				province: [],
				cityList: [],
				city: undefined,

				collegeList: [],
				college: undefined,

				dataList: [],
				total: 0,
				dataTips: undefined,
				columnList: ['专业大类', '专业类', '专业'],

				sector: undefined,
				childSector: '',
				degreeList: [],
				degree: undefined,

				queryParams: {
					page: 1,
					pageSize: 20
				},

				groupQueryParams: {
					page: 1,
					pageSize: 10
				},
				spanArr: [], // 存储合并信息
				pos: 0, // spanArr的索引位置,
				clgRankData: null,
				showClgRankDialog: false,
				showGroupDialog: false,
				groupName: '',
				groupAddList: [{
						'name': '未添加',
						'value': 2
					},
					{
						'name': '已添加',
						'value': 1
					},
				],
				groupAddState: 2,
				groupAddIndex: 0,
				showGroupMajorDialog: false,
				groupDataList: [],
				groupMajorNum: 0,
				groupTotal: 0,
				yearList: [],
				year: 2023,
				sectorTree: [],
				childIndustryList: [],
				hasLogin: 3,
				levelList: [],
				level: '',
				degreeLevel: ''
			}
		},
		
		setup() {
			const loginStore = useLoginStore()
		
			// 返回 store 到模板中使用
			return {
				loginStore
			}
		},
		
		created() {
			console.log('params', this.$route.query)
			this.initPageData();
		},
		watch: {
			// major(newVal, oldVal){
			// 	console.log('值变化了', newVal, oldVal);
			// 	if(newVal != oldVal && newVal != ''){
			// 		this.onMajorChange(newVal)
			// 	}
			// }
		},
		methods: {
			initPageData() {
				this.loadConfig();
				this.getUserMajorGroup();
				this.initPassParams();
			},

			loadConfig() {
				getGroupPageConfig().then(res => {
					this.provinceList = res.data.provinceList;
					this.levelList = res.data.levelList;
					let params = this.$route.query
					if (!isEmpty(params.activeLeftTab)) {
						this.province = params.province_code;
						this.city = params.city_code;
					}
				});
			},

			initPassParams() {
				let params = this.$route.query
				console.log('initPassParams params', params)
				let hasParams = false;
			},
			
			loadGroupMajorList(query) {
				console.log('loadMajorList query', query)
				getGroupMajorList({
					name: query,
					top_code: this.topMajor,
					parent_code: this.parentMajor,
					degreeLevel: this.degreeLevel
				}).then(res => {
					this.majorList = res.data.majorList;
					this.major = ''
				});
			},
			
			loadGroupParentMajorList(query) {
				getGroupParentMajorList({
					name: query,
					top_code: this.topMajor,
					degreeLevel: this.degreeLevel
				}).then(res => {
					this.parentMajorList = res.data.parentMajorList;
					this.parentMajor = ''
					console.log('clear major--------')
				});
			},
			
			loadGroupTopMajorList(query) {
				getGroupTopMajorList({
					name: query,
					degreeLevel: this.degreeLevel
				}).then(res => {
					this.topMajorList = res.data.topMajorList;
				});
			},

			getUserMajorGroup() {
				getUserMajorGroup(this.queryParams).then(res => {
					this.hasLogin = res.data.hasLogin;
					if(this.hasLogin == 1){
						this.dataList = res.data.list;
						this.total = res.data.pageData.totalCount;
					}
				});
			},

			createUserGroup() {
				this.groupName = '';
				this.province = ''
				this.level = ''
				this.showGroupDialog = true;
			},

			confirmCreateGroup() {
				let provinces = this.province.join(',');
				createMajorGroup({
					'name': this.groupName,
					'province': provinces,
					'level': this.level
				}).then(res => {
					this.getUserMajorGroup();
					this.showGroupDialog = false;
				})
			},

			clickEditGroupMajor(row) {
				let id = row.id;
				this.showGroupMajorDialog = true;
				this.curGroupId = id;
				this.groupDataList = [];
				this.groupMajorNum = 0;
				this.topMajor = '';
				this.parentMajor = '';
				this.major = '';
				this.parentMajorList = []
				this.majorList = [];
				this.groupQueryParams.page = 1;
				this.groupAddIndex = 0;
				this.groupAddState = this.groupAddList[this.groupAddIndex]['value']
				this.degreeLevel = row.degreeLevel;
				this.loadGroupTopMajorList();
				this.queryGroupMajorData();
			},

			clickCloseGroupDialog() {
				if (this.groupMajorNum > 0){
					this.showGroupMajorDialog = false;
					this.onGroupDialogClosed();
					let path = '/sameIndustry?id=' + this.curGroupId;
					this.$router.push(path);
				}else{
					Notification.error({
						title: '请先设置专业',
						zIndex: 9000000
					})
				}
			},

			clickIndustry(path) {
				this.$router.push(path);
			},

			clickExportGroupReport(id) {

			},

			clickDelUserGroup(id) {
				this.$modal.confirm('确定要删除该条数据吗？').then(() => {
					deleteUserGroup({
						'id': id
					}).then(res => {
						this.getUserMajorGroup();
					})
				})
			},

			clickAddTab(index) {
				this.topMajor = '';
				this.parentMajor = '';
				this.major = '';
				this.parentMajorList = []
				this.majorList = [];
				this.groupQueryParams.page = 1;
				this.groupAddIndex = index;
				this.groupAddState = this.groupAddList[index]['value']
				this.queryGroupMajorData();
			},

			changeGroupTopMjor(value) {
				this.loadGroupParentMajorList('');
				this.majorList = []
				this.major = ''
				this.groupQueryParams.page = 1;
				this.queryGroupMajorData();
			},

			changeGroupParentMajor(value) {
				this.groupQueryParams.page = 1;
				this.loadGroupMajorList('');
				this.queryGroupMajorData();
			},

			changeGroupMajor(value) {
				this.groupQueryParams.page = 1;
				this.queryGroupMajorData();
			},

			queryGroupMajorData() {
				this.groupQueryParams.group_id = this.curGroupId;
				this.groupQueryParams.top_code = this.topMajor;
				this.groupQueryParams.parent_code = this.parentMajor;
				this.groupQueryParams.code = this.major;
				this.groupQueryParams.isAdd = this.groupAddState;
				this.groupQueryParams.degreeLevel = this.degreeLevel;
				this.groupQueryParams.from = 'group'
				getGroupMajor(this.groupQueryParams).then(res => {
					this.groupDataList = res.data.list;
					this.groupMajorNum = res.data.majorNum;
					this.groupTotal = res.data.pageData.totalCount;
				});
			},

			clickAddGroupMajor(code) {
				let params = {
					'group_id': this.curGroupId,
					'code': code
				}
				addGroupMajor(params).then(res => {
					this.queryGroupMajorData();
				});
			},

			clickRemoveGroupMajor(code) {
				let params = {
					'group_id': this.curGroupId,
					'code': code
				}
				removeGroupMajor(params).then(res => {
					this.queryGroupMajorData();
				});
			},

			onGroupDialogClosed() {
				this.getUserMajorGroup();
			},

			clickRoute(item) {
				console.log('item', item)
				let data = parse(item.url)

				if (data['head'] == 'replace') {
					let url = "/" + data['path'];
					if (data['data'] != null && data['data'].length != 0) {
						url += "?" + data['data'];
					}
					console.log('url', url)
					// this.$router.replace(url);
					this.$router.push(url);
				} else {
					handleRouteProtocal(data)
				}
			},
			
			clickLogin(){
				this.loginStore.openLoginDialog()
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "group.scss";
</style>